<template>
  <section
    id="about-me-section"
    class="common-padding text-flax-smoke-200 relative z-10 overflow-y-clip rounded-b-3xl bg-[#0B0B0A] shadow-2xl will-change-auto sm:mt-0"
  >
    <div class="md:column-gap grid grid-cols-12">
      <div class="hide-on-mobile overflow-hidden md:col-span-4">
        <svg
          id="down-arrow-2"
          stroke="currentColor"
          fill="none"
          stroke-width="1.25"
          viewBox="6 6 12 12"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="hide-on-mobile m-0 size-20 -translate-x-full p-0"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line x1="7" y1="7" x2="17" y2="17"></line>
          <polyline points="17 7 17 17 7 17"></polyline>
        </svg>
      </div>

      <h3
        id="little-bit-about-me"
        v-html="aboutMe"
        class="heading-1-alt lg:heading-1 section-heading col-span-full leading-none font-bold uppercase md:col-span-8 md:col-start-6 text-gradient-draftex"
      ></h3>
    </div>

    <div class="padding-y md:column-gap mt-6 grid grid-cols-12">
      <div
        class="pointer-events-none col-span-full content-center rounded-lg select-none md:col-span-5"
      >
        <img
          :src="logo"
          class="w-full h-auto rounded-lg mix-blend-screen brightness-90"
          alt="DRAFTEX logo"
        />
      </div>
      <div class="col-span-full mt-10 md:col-span-7 md:col-start-6">
       <p
          class="heading-4 relative w-full max-w-[40ch] leading-snug font-medium text-balance"
        >
          DRAFTEX is a next-gen design and digital solutions agency built for speed, creativity, 
          and results.We help brands turn ideas into powerful digital experiences using smart 
          strategy and AI-driven execution.Focused on quality, affordability, and fast delivery, 
          we partner with businesses to scale and stand out.

        </p>


        <div
          class="text-flax-smoke-300 mt-[5%] flex justify-start gap-10 sm:gap-20"
        >
          <p class="heading-6 text-flax-smoke-300/85 text-center text-nowrap">
            ( ABOUT ME )
          </p>
              <p class="heading-6 font-fancy w-full text-balance sm:max-w-[40ch]">
         At DRAFTEX, we are a team of passionate creators and strategists dedicated to 
        turning ideas into meaningful digital solutions. Built on collaboration and innovation, 
        we bring together design, technology, and marketing to deliver work that is both 
        visually impactful and performance-driven. Our approach is simple—understand 
        the vision, create with purpose, and execute with precision. We focus on building 
        long-term partnerships by delivering consistent quality, transparent communication, 
        and solutions that truly add value to our clients’ growth.

      </p>
        </div>

      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import {
    animateSplitText,
    xToZero,
    animateAboutMeSectionLeave,
  } from '@/animations';
  import logo from '@/assets/images/logo.webp';
  import { textSplitterIntoChar } from '@/functions';
  import { onBeforeMount, onMounted, ref } from 'vue';

  const aboutMe = ref('ٍSelected Projects /');
  


  // const initialPath = ref(`M0 0H${width.value}  V${height.value} H0 Z`);
  // const targetPath = ref(
  //   `M0 0H${width.value}L${width.value * 0.9} ${height.value}H${width.value * 0.1}L0 0Z`,
  // );

 onBeforeMount(() => {
  aboutMe.value = textSplitterIntoChar(
    'Draftex',
    true,
    true,
  );
});


  onMounted(() => {
    animateSplitText(
      '#little-bit-about-me .letters',
      '#little-bit-about-me',
      1,
      0.01,
      0,
      () => {
        xToZero('#down-arrow-2');
      },
    );

    animateAboutMeSectionLeave('#about-me-section');
  });
</script>
